export const parseToFloat = (value: string, defaultValue = 0) => {
  const parsed = Number.parseFloat(value);
  return isNaN(parsed) ? defaultValue : parsed;
};
